
// Auto indicação
export const AutoIndicacao = 9;
export const Cancelamento = 29;